import { Row, Col, Button } from "antd";
import React, { Component } from "react";
import PlantOrder from "../../components/DashboardStatsCard/plantorder";
import { connect } from "react-redux";
import { DashboardAction, UserAction } from "../../store/actions";
import moment from "moment";
import CustomModal from "../../components/modals/customModal";
import DeleteOrder from "../../assets/images/delete_order.png";

class PlantContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
      },
      isClose: false,
      isOpenModal: false,
      isOpenLogisticModal: false,
      userId: "",
      isAllow: "",
    };
  }
  componentDidMount() {
    const { getManufacturePlants } = this.props;

    const companyId = this.props.user?.[1]?.platform_owner?.id;

    if (companyId) {
      getManufacturePlants(this.state.filter);
    }
  }
  componentDidUpdate(preProps, preState) {
    const { getManufacturePlants } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filter.page !== this.state.filter.page ||
      preState.filter.search !== this.state.filter.search
    ) {
      getManufacturePlants(this.state.filter);
    }
  }
  toggleModal = () => {
    this.setState({
      isOpenModal: false,
      isOpenLogisticModal: false,
    });
  };

  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };

  onChangeTab = (key) => {
    const { getManufacturePlants } = this.props;

    if (key == "1") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "",
        },
      });

      getManufacturePlants({ ...this.state.filter, status: "" });
    }
    if (key == "2") {
      this.setState({
        filter: {
          ...this.state.filter,
        },
        status: "pending",
      });
      getManufacturePlants({
        ...this.state.filter,
        status: "pending",
      });
    }
    if (key == "3") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "active",
        },
      });
      getManufacturePlants({
        ...this.state.filter,
        status: "active",
      });
    }
    if (key == "4") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "rejected",
        },
      });
      getManufacturePlants({
        ...this.state.filter,
        status: "rejected",
      });
    }
    if (key == "5") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "inactive",
        },
      });
      getManufacturePlants({
        ...this.state.filter,
        status: "inactive",
      });
    }
    if (key == "6") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "unsubscribed",
        },
      });
      getManufacturePlants({
        ...this.state.filter,
        status: "unsubscribed",
      });
    }
  };
  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };

  previousPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };
  onChangeText = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: e.target.value,
      },
    });
  };

  onSearchLogistics = (e) => {
    this.setState({
      logisticsfilter: {
        ...this.state.logisticsfilter,
        search: e.target.value,
      },
    });
  };

  onChangeFilter = (end_date, start_date) => {
    // this.setState({
    //   filter: {
    //     ...this.state.filter,
    //     start_date,
    //     end_date,
    //   },
    // });
  };
  onChangePeriod = (period) => {
    this.setState({
      filter: {
        ...this.state.filter,
        period,
      },
    });
  };

  handleModal = () => {
    this.state.isOpenModal &&
      this.props.plantActivation(
        this.state.userId,
        () => {
          this.toggleModal();
          this.props.getManufacturePlants(this.state.filter);
        },
        "deactivate"
      );
  };
  render() {
    const { isOpenModal, isOpenLogisticModal } = this.state;
    const columns = [
      {
        title: "RMX NAME",
        dataIndex: "",
        align: "left",
        key: "business_name",
        width: '20%',
        sorter: (a, b) => a.business_name?.localeCompare(b.business_name),
        render: (r) => {
          return (
            <div>
              <span
                style={{ color: "#09c1b2" }}
                onClick={() =>
                  this.props.history.push({
                    pathname: `/rmx/${r.id}/orders`,
                    state: r,
                  })
                }
                className="pointer-cursor text-capitilize"
              >
                {r?.business_name}
              </span>
            </div>
          );
        },
      },
      {
        title: "DATE",
        dataIndex: "",
        align: "left",
        key: "created_at",
        width: '20%',
        sorter: (a, b) => a.created_at.localeCompare(b.created_at),
        render: (r) => (
          <div>
            <span>{moment(r?.created_at).format("MM-DD-YYYY")}</span>
          </div>
        ),
      },
      {
        title: "STATUS",
        dataIndex: "",
        align: "left",
        key: "email",
        sorter: (a, b) => a.email.localeCompare(b.email),
        render: (r) => (
          <div>
            {r.status == 2
              ? "Active"
              : r.status == 1
                ? "Pending"
                : r.status == 5
                  ? "Unsubscribed"
                  : "Inactive"}
          </div>
        ),
      },
      {
        title: "ACTION",
        dataIndex: "",
        align: "left",
        className: "action-class",
        width: '20%',
        render: (r) => (
          <div>
            <span
              className="st-primary pointer-cursor"
              onClick={() =>
                r.status == 3 || r.status == 1 || r.status == 4
                  ? this.props.plantActivation(
                    r.id,
                    () => this.props.getManufacturePlants(this.state.filter),
                    "activate"
                  )
                  : this.setState({
                    isOpenModal: !this.state.isOpenModal,
                    userId: r.id,
                    isAllow: r.status,
                  })
              }
              style={{
                color: r.status == 2 ? "red" : "#26a69a",
                display: "contents",
              }}
            >
              {r.status == 1 ? (
                <>
                  <span
                    style={{
                      color: "#26a69a",
                      paddingRight: "5px",
                      fontSize: "12px",
                    }}
                    className="onhover"
                  >
                    APPROVE
                  </span>
                  <span
                    style={{ color: "red", fontSize: "12px" }}
                    className="onhover"
                  >
                    REJECT
                  </span>
                </>
              ) : r.status === 2 ? (
                <span
                  style={{ color: "#ff0404", fontSize: "12px" }}
                  className="onhover"
                >
                  DEACTIVATE
                </span>
              ) : r.status === 3 ? (
                <span
                  style={{ color: "#26a69a", fontSize: "12px" }}
                  className="onhover"
                >
                  ACTIVATE
                </span>
              ) : r.status === 4 ? (
                <span
                  style={{ color: "#26a69a", fontSize: "12px" }}
                  className="onhover"
                >
                  APPROVE
                </span>
              ) : (
                <span>-</span>
              )}
            </span>
          </div>
        ),
      },
      {
        title: "CATALOG CUSTOMIZATION",
        dataIndex: "",
        align: "left",
        className: "action-class",
        width: '20%',
        render: (r) => (
          <p
            className="st-primary pointer-cursor "
            onClick={() => {
              r.allowed_for_catalog_customization === true
                ? this.props.plantActivation(
                  r.id,
                  () => this.props.getManufacturePlants(this.state.filter),
                  "restrict_catalog_customization"
                )
                : this.props.plantActivation(
                  r.id,
                  () => this.props.getManufacturePlants(this.state.filter),
                  "allow_catalog_customization"
                );
            }}
            style={{
              color: "#26a69a",
              display: "contents",
            }}
          >
            {r.allowed_for_catalog_customization === true ? (
              <span className="onhover" style={{ fontSize: "12px" }}>
                RESTRICT
              </span>
            ) : (
              <span className="onhover" style={{ fontSize: "12px" }}>
                ALLOW
              </span>
            )}
          </p>
        ),
      },
    ];

    return (
      <Row justify="space-between">
        <Col span={24} style={{ marginTop: '-10px' }}>
          <PlantOrder
            {...this.props}
            inputText={"All Manufacturing Plants"}
            onChangeTab={this.onChangeTab}
            metaData={this.state.filter}
            currentPage={this.currentPage}
            previousPage={this.previousPage}
            onChangeText={this.onChangeText}
            onChangeFilter={this.onChangeFilter}
            onChangePeriod={this.onChangePeriod}
            columns={columns}
            isShowManufacturingPlants={true}
            isShowPlusSign={true}
            onClearSearch={() =>
              this.setState({
                filter: { ...this.state.filter, search: "" },
              })
            }
            searchVal={this.state.filter.search}
          />
        </Col>
        <CustomModal
          visible={isOpenModal || isOpenLogisticModal}
          onCancelModal={this.toggleModal}
          footer={[
            <Row justify="center">
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.handleModal()}
                >
                  YES
                </Button>
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.toggleModal()}
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" style={{marginBottom:'30px'}}>
              <img src={DeleteOrder} />
            </Col>
            <Col >
              <p>
                {this.state.isOpenLogisticModal == true
                  ? "Are you sure you want to deactivate this logistic partner?"
                  : "Are you sure you want to deactivate this plant company?"}
              </p>
            </Col>
          </Row>
        </CustomModal>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    Orders: store.DashboardReducer.orders,
    manufacturePlants: store.DashboardReducer.manufacturePlant,
    user: store.AuthReducer.user,
    metaData: store.DashboardReducer.metaData,
    loading: store.DashboardReducer.isLodadingCount,
    isLoader: store.DashboardReducer.isOrder,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getManufacturePlants: (params) =>
      dispatch(DashboardAction.getManufacturePlantReq(params)),
    plantActivation: (id, cb, params) =>
      dispatch(DashboardAction.plantActivationReq(id, cb, params)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PlantContainer);
